import post from '@/api/core/http/post'
import { buildApiUrl } from '@/api/core/url'
import { TypedMutationsOptions } from '@/api/core/mutation/options'
import { useMutation } from '@tanstack/react-query'
import { ApiError } from '@/api/core/errors'
import {
  ArcadeSettingsInput,
  ArcadeSettingsResponse,
  setArcadeSettingsResponseSchema
} from './schema'

const path = `/arcade/season/set/delete_me`

export const setArcadeSettings = async ({
  season_id,
  time_start,
  time_end,
  rank_threshold
}: ArcadeSettingsInput): Promise<ArcadeSettingsResponse> =>
  post<ArcadeSettingsResponse>(
    buildApiUrl(path, {
      season_id: season_id.toString(),
      time_start: time_start.toString(),
      time_end: time_end.toString(),
      rank_threshold: rank_threshold.toString()
    }),
    {},
    setArcadeSettingsResponseSchema
  )

export const useArcadeSettingsMutation = (
  mutationOptions?: TypedMutationsOptions<
    ArcadeSettingsResponse,
    ArcadeSettingsInput
  >
) => {
  return useMutation<ArcadeSettingsResponse, ApiError, ArcadeSettingsInput>(
    params => setArcadeSettings(params),
    mutationOptions
  )
}
